import { ReactElement, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import ModalImg from 'src/assets/images/create-brand-modal.png';
import { IModal } from './types';
import { getChannelsAddons } from 'src/api/getChannelsAddons/getChannelsAddons';
import { ModalContent } from './ModalContent';
import { useUserTracking } from 'src/hooks';
import { Modal } from '@weareopenr/component-library';

const ChannelModal = ({
  variant,
  closeModal,
  open,
  currentBrand,
  refetch,
  configurationId,
}: Omit<IModal, 'data'>): ReactElement => {
  const { captureException } = useUserTracking();
  const { data, isLoading, error } = useQuery({
    queryKey: ['channels-addons'],
    queryFn: getChannelsAddons,
  });
  useEffect(() => captureException(error), [error]);

  return (
    <Modal closeModal={closeModal} open={open} image={ModalImg} imageAlt="Picture of Sides">
      <ModalContent
        currentBrand={currentBrand}
        variant={variant}
        refetch={refetch}
        closeModal={closeModal}
        isFetching={isLoading}
        data={data}
        configurationId={configurationId}
      />
    </Modal>
  );
};

export default ChannelModal;
